export default __webpack_public_path__ + "e28292cdf17614bc1af25ebd9391f21a.png";